import React from 'react';

import { Button, Result } from 'antd';
import { Link } from 'react-router-dom';
import { T } from 'react-translator-component';

/**
 * O que a área de conteúdo mostra quando a conta não tem o módulo daquele endereço.
 *
 * Não é erro de carga nem endereço inexistente — é permissão —, por isso não reaproveita
 * o /not-found nem o Result de falha da tela: quem chegou aqui digitou (ou recebeu) um
 * link válido, e precisa saber que o caminho existe mas não é dela.
 *
 * Result do antd, como o resto do repo faz para estado vazio e de erro. O botão volta para
 * a home porque a página em si não tem nada a tentar de novo.
 */
export const AccessUnavailable: React.FC = () => (
  <Result
    status="403"
    title={T('This module is not available for your account.')}
    subTitle={T(
      'Your account does not have access to this area. Talk to the administrator if you need it.',
    )}
    extra={
      <Link to="/">
        <Button type="primary">{T('Back to home')}</Button>
      </Link>
    }
  />
);

export default AccessUnavailable;
